import * as React from "react";
import { Button, useNotify } from "react-admin";
import ApiClient from "../../ApiClient";
import API from "../../Routes";
import { Download } from "@mui/icons-material";

const DownloadJobDescriptionButton = ({ url }) => {
  const notify = useNotify();
  const hasUrl = !!url;

  return (
    <Button
      variant="contained"
      label="Download"
      disabled={!hasUrl}
      startIcon={<Download />}
      onClick={async () => {
        try {
          const response = await ApiClient.fetch(API.JOB_DESCRIPTIONS.DOWNLOAD_URL, {
            method: "POST",
            body: JSON.stringify({ url }),
          });

          const presignedUrl = response.json?.presignedUrl;
          if (!presignedUrl) {
            throw new Error("Presigned URL not returned");
          }

          window.open(presignedUrl, "_blank", "noopener,noreferrer");
        } catch (error) {
          notify(
            `Failed to download job description: ${error?.message || error}`,
            { type: "error" }
          );
        }
      }}
    />
  );
};

export default DownloadJobDescriptionButton;
